// extracted by mini-css-extract-plugin
export default {"title":"SendSuccess_title__t2wzs","secondary":"SendSuccess_secondary__cTkT4","email":"SendSuccess_email__6M-6g","resendEmail":"SendSuccess_resendEmail__l8WQF"};